import { useUpdateDeviceSyncMutation } from "../../store/storageRoles/devicesSharedApi";

const useUpdateDeviceSyncData = () => {
  const [
    updateDeviceSync,
    {
      data: updateDeviceSyncData,
      isLoading: updateDeviceSyncIsLoading,
      isSuccess: updateDeviceSyncIsSuccess,
      isError: updateDeviceSyncIsError,
      error: updateDeviceSyncError,
    },
  ] = useUpdateDeviceSyncMutation();

  return {
    updateDeviceSync,
    updateDeviceSyncIsLoading,
    updateDeviceSyncIsSuccess,
    updateDeviceSyncIsError,
    updateDeviceSyncError,
    updateDeviceSyncData,
  };
};

export default useUpdateDeviceSyncData;
